module.exports = __webpack_public_path__ + "static/media/video-inapp.ed64fe93.gif";